export default {"src":"/_next/static/media/form-editor-brush.e09a6ad9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};